export default {
    CREATE_RESERVATION_REQUEST_REQUEST: 'RESERVATION_REQUEST_NEW_CREATE_RESERVATION_REQUEST_REQUEST',
    CREATE_RESERVATION_REQUEST_SUCCESS: 'RESERVATION_REQUEST_NEW_CREATE_RESERVATION_REQUEST_SUCCESS',
    GET_COURSE_REQUEST: 'RESERVATION_REQUEST_NEW_GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS: 'RESERVATION_REQUEST_NEW_GET_COURSE_SUCCESS',
    COURSE_SCENARIOS_REQUEST: 'RESERVATION_REQUEST_NEW_COURSE_SCENARIOS_REQUEST',
    COURSE_SCENARIOS_SUCCESS: 'RESERVATION_REQUEST_NEW_COURSE_SCENARIOS_SUCCESS',
    SCENARIOS_REQUEST: 'RESERVATION_REQUEST_NEW_SCENARIOS_REQUEST',
    SCENARIOS_SUCCESS: 'RESERVATION_REQUEST_NEW_SCENARIOS_SUCCESS',
    SEARCH_INVENTORY_ITEMS_REQUEST: 'RESERVATION_REQUEST_NEW_SEARCH_INVENTORY_ITEMS_REQUEST',
    SEARCH_INVENTORY_ITEMS_SUCCESS: 'RESERVATION_REQUEST_NEW_SEARCH_INVENTORY_ITEMS_SUCCESS',
    GET_SIMULATORS_COMPANIES_REQUEST: 'RESERVATION_REQUEST_GET_SIMULATORS_COMPANIES_REQUEST',
    GET_SIMULATORS_COMPANIES_SUCCESS: 'RESERVATION_REQUEST_GET_SIMULATORS_COMPANIES_SUCCESS',
    DISPOSE: 'RESERVATION_REQUEST_NEW_DISPOSE_STORE',
};
